// extracted by mini-css-extract-plugin
export var answer = "bk_fQ";
export var arrow = "bk_9";
export var body = "bk_c";
export var category = "bk_bW";
export var contactIcons = "bk_fJ";
export var current = "bk_d6";
export var fade = "bk_fM";
export var footer = "bk_bR";
export var footerText = "bk_bS";
export var icon = "bk_bz";
export var iconContainer = "bk_cX";
export var issue = "bk_fP";
export var issueContainer = "bk_fL";
export var issueText = "bk_fN";
export var issues = "bk_fK";
export var left = "bk_b8";
export var padding = "bk_dj";
export var right = "bk_ck";
export var section = "bk_j";
export var selectors = "bk_dM";
export var subtitle = "bk_b7";
export var title = "bk_g";